import { Routes } from '@angular/router';

export const CHATBOT_ROUTES: Routes = [
    {
        // TODO: introduce typings for the Routes data
        data: {
            icon: 'robot',
            // module: 'CHATBOT',
            showBreadcrumb: false,
            reuse: true,
        },
        path: 'chatbot',
        title: 'Chatbot',
        loadComponent: () => import('./chatbot.component').then((c) => c.ChatbotComponent),
    },
];
